import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Truck } from 'react-bootstrap-icons';
import { Statistic, Descriptions } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ProvidersView = function ProvidersView(_ref) {
  var _ref$providersList = _ref.providersList,
    providersList = _ref$providersList === void 0 ? null : _ref$providersList;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        margin: '10px 0px 10px 0px'
      },
      children: /*#__PURE__*/_jsx(Truck, {
        size: 45
      })
    }), /*#__PURE__*/_jsx(Row, {
      children: providersList != null && providersList.map(function (p) {
        return /*#__PURE__*/_jsxs(Col, {
          lg: 4,
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx("b", {
              children: p.label
            })
          }), /*#__PURE__*/_jsx(Statistic, {
            title: "Balance",
            value: p.balance,
            prefix: "GNF"
          })]
        }, p.id);
      })
    })]
  });
};
export default ProvidersView;